import { render, staticRenderFns } from "./rounded-spinner.vue?vue&type=template&id=1edb1d6f&"
import script from "./rounded-spinner.vue?vue&type=script&lang=js&"
export * from "./rounded-spinner.vue?vue&type=script&lang=js&"
import style0 from "./rounded-spinner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports